import {
  STATUS_WAIT,
  STATUS_ENDED,
  STATUS_SELLING,
  // LAST_BEGIN,
  // LAST_END,
  HOST_STATIC,
  DIR_RES,
  DIR_CSS,
  DIR_IMG,
  // PRE_END,
  HOST_WEB,
  ERR_GOODS_404,
  ERR_CANT_BUY,
  ERR_SALE_NOT_BEGIN,
  // ERR_SALE_IS_ENDED,
  ERR_PRE_IS_ENDED,
  ERR_PAYED_LAST,
  ERR_PAYED_PRE,
  ERR_NEED_LOGIN,
  ERR_NEED_MOBILE
} from './const';
import {
  leftSecs,
  sec2txt
} from '../common/utils';
import {
  WZUtils
} from '../common/globals';

// CND资源路径
function _cdnSrc(state, src, appDir) {
  if (src) {
    if (/^\/\w/.test(src)) { //根目录：  /a/b/c.jpg
      src = 'https://' + HOST_STATIC + src
    } else if (/^\w/.test(src) && !/^https?:\/\//.test(src)) { //本项目：  a/b/c.jpg
      appDir = appDir || DIR_RES
      src = appDir + src
    }
    return src
  }
  return ''
}

// 根据goodsId 查询商品信息
function _goods(state, goodsId) {
  const {
    goodsMap
  } = state
  if (goodsMap && goodsMap[goodsId]) {
    return goodsMap[goodsId]
  }
  return null
}

/**
 * 获取购买信息
 * @param {object} state 状态
 * @param {number} isLast 是否为尾款 0: 定金  1：尾款
 */
function _buyInfo(state, isLast) {
  const buyInfos = state.buyInfos || {}
  return isLast ? buyInfos.last : buyInfos.pre
}

/**
 * 获取我支付过的商品ID
 * @param {object} state 状态
 * @param {number} isLast 是否为尾款 0: 定金  1：尾款
 */
function _myGid(state, isLast) {
  const info = _buyInfo(state, isLast)
  return info && info.goodsId > 0 ? +info.goodsId : 0
}

function myPre(state) {
  return _buyInfo(state, 0)
}

function myLast(state) {
  return _buyInfo(state, 1)
}

// 判断指定的商品的类型
function _isTypeOf(type, state, goodsId) {
  const goods = _goods(state, goodsId)
  return !!goods && goods.type === type
}

// 计算剩余时长
// function _leftSecs(endTime) {
//   const nowTime
// }

function dirCss() {
  return DIR_CSS
}

function dirImg() {
  return DIR_IMG
}

function imgSrc(state) {
  return (src) => _cdnSrc(state, src, DIR_IMG)
}
// function cssSrc(state) {
//   return (src) => _cssSrc(state, src )
// }
// function jsSrc(state) {
//   return (src) => _jsSrc(state, src )
// }

// 是否为预定商品
function _isPre(state, goodsId) {
  return _isTypeOf('pre', state, goodsId)
}

function isPre(state) {
  return (goodsId) => _isPre(state, goodsId)
}
// 是否为尾款商品
function _isLast(state, goodsId) {
  return _isTypeOf('last', state, goodsId)
}

function isLast(state) {
  return (goodsId) => _isLast(state, goodsId)
}

function _isPhysical(state, goodsId) {
  const goods = _goods(state, goodsId)
  return !!goods && !!goods.isPhysical
}

// 判断是否购买过指定的商品

function isPayed(state) {
  return (goodsId) => {
    goodsId = +goodsId
    if (goodsId > 0 && _goods(state, goodsId)) {
      return goodsId === myGidPre(state) ? true : goodsId === myGidLast(state)
    }
    return false
  }
}


function _chkBuy(state, goodsId) {
  const {
    canGoodsIds,
    userInfo
  } = state
  // alert(leftSecsPre(state))
  if (!userInfo || !userInfo.uid) { // 未登录
    return ERR_NEED_LOGIN
  } else if (!userInfo.mobile) { // 未绑定手机号
    return ERR_NEED_MOBILE
    // } else if (leftSecsEnd(state) < 1) { // 已结束
    //   return ERR_SALE_IS_ENDED
  } else if (_isPre(state, goodsId)) { // 预付
    if (leftSecsPre(state) < 1) { // 预付定金时期已结束
      return ERR_PRE_IS_ENDED
    } else if (myGidPre(state) > 0) { // 已支付过定金
      return ERR_PAYED_PRE
    }
  } else if (_isLast(state, goodsId)) { // 尾款
    if (leftSecsBegin(state) > 0) { // 未开始
      // alert(leftSecsBegin(state));
      return ERR_SALE_NOT_BEGIN
    } else if (myGidLast(state) > 0) { // 已购买过尾款
      return ERR_PAYED_LAST
      // } else if (leftSecsEnd(state) < 1) { // 已结束
      //   return ERR_SALE_IS_ENDED
    }
  }
  const goods = _goods(state, goodsId)
  if (!goods) { // 商品不存在
    return ERR_GOODS_404
  }
  // alert(state.canGoodsIds)
  if (!canGoodsIds || canGoodsIds.indexOf(goodsId) < 0) { // 不能购买
    // TODO: 区分已支付定金，待支付尾款
    return ERR_CANT_BUY
  }
  return 0
}

// 根据商品ID，查询出对应的预定多商品ID
function toPreId(state) {
  return (goodsId) => {
    const goods = _goods(state, goodsId)
    if (goods) {
      if (goods.type === 'pre') {
        return goodsId
      } else  {
        return goods.preId > 0 ? goods.preId : 0
      }
    }
    return 0
  }
}

// 已购买的商品ID
function myGidPre(state) {
  return _myGid(state, 0)
}

function myGidLast(state) {
  return _myGid(state, 1)
}

// 待支付尾款商品ID
function waitLastId(state) {
  if (myGidPre(state) > 0 && !myGidLast(state)) {
    const {
      canGoodsIds
    } = state
    return canGoodsIds && canGoodsIds[0] > 0 ? +canGoodsIds[0] : 0
  }
  return 0
}

function chkBuy(state) {
  return (goodsId) => _chkBuy(state, goodsId)
}

function canBuy(state) {
  return (goodsId) => _chkBuy(state, goodsId) === 0
}

function saleStatus(state) { // wait 未开始  selling: 进行中  ended：已结束
  // const _now = WZUtils.getServerTime()
  const {
    _now,
    LAST_BEGIN,
    LAST_END
  } = state
  if (_now && _now > LAST_BEGIN) {
    return _now > LAST_END ? STATUS_ENDED : STATUS_SELLING
  }
  return STATUS_WAIT
}


function isLoaded(state) { // wait 未开始  selling: 进行中  ended：已结束
  // const nowTime = WZUtils.getServerTime()
  const {
    preMap,
    lastMap,
    goodsMap
  } = state
  return !!preMap && !!lastMap && !!goodsMap
}


// function buyPreStatus(state) { //0: 未支付， 1: 已支付(有效期内)， 2:已支付(已过期)
//   if (_myGid(state, 0) > 0) {
//     return saleStatus(state) === STATUS_ENDED ? PRE_BUY_EXPIRED : PRE_BUY_OK
//   }
//   return PRE_BUY_NONE
// }

// function buyLastStatus(state) { //0: 未支付， 1： 已支付
//   if (_myGid(state, 1) > 0) {
//     return LAST_BUY_OK
//   }
//   return LAST_BUY_NONE
// }

function goodsInfo(state) { // 根据goodsId 查询商品信息
  return (goodsId) => _goods(state, goodsId)
}

// function myGidPre(state) { //已购买：定金商品ID
//   return _getPayedId(state, 0)
// }

// function myGidLast(state) { //已购买：尾款商品ID
//   return _getPayedId(state, 1)
// }

// 倒计时
function leftSecsPre(state) {
  return leftSecs(state._now, state.PRE_END)
}

function leftSecsBegin(state) {
  return leftSecs(state._now, state.LAST_BEGIN)
}

function leftSecsEnd(state) {
  return leftSecs(state._now, state.LAST_END)
}

function isPrePaying(state) {
  return leftSecsPre(state) > 0
}
// 尾款支付中
function isLastPaying(state) {
  return leftSecsEnd(state) > 0 && leftSecsBegin(state) <= 0
}


export default {
  dirCss,
  dirImg,
  imgSrc,
  // cssSrc,
  // jsSrc,
  isLoaded,
  goodsInfo,
  waitLastId,
  myGidPre,
  myGidLast,
  myPre,
  myLast,
  chkBuy,
  canBuy,
  saleStatus,
  // buyPreStatus,
  // buyLastStatus,
  isPayed,
  isPre,
  isLast,
  leftSecsPre,
  leftSecsBegin,
  leftSecsEnd,
  isPrePaying,
  isLastPaying,

  sec2txt() {
    return (secs, mode) => sec2txt(secs, mode)
  },
  urlKline() {
    return `https://${HOST_WEB}/award/klinev2/`
  },
  errorMsg() {
    return WZUtils.getErrorMsg
  },
  HOST_WEB() {
    return HOST_WEB
  },
  HOST_STATIC() {
    return HOST_STATIC
  },
  stage2text() {
    return (stage) => {
      const O = {
        0: '注册会员',
        1: '白银王粉',
        2: '黄金王粉',
        3: '钻石王粉',
        4: '至尊王粉'
      }
      return O[stage] || `stage(${stage})`
    }
  },

  // 是否需要补充地址
  isPhysical(state) {
    return (goodsId) => {
      return _isPhysical(state, goodsId)
    }
  },

  // 是否需要补充地址
  needAddress(state) {
    const last = myLast(state)
    if (last && !last.addressOk && !!last.bbsOrderId && last.goodsId) {
      // alert(JSON.stringify([_isPhysical(state, last.goodsId), last], null, 2))
      return _isPhysical(state, last.goodsId)
    }
    return false
  },

  canPayLast(state) {
    const pre = myPre(state);
    const last = myLast(state);
    if (pre && !last) { // 已付首款，未付尾款
      return isLastPaying(state)
    }
    return false
  },
  toPreId
}
